/**
 * A nomination as people name it, "Chambers Europe 2027 · Banking & finance": its directory edition, then its
 * practice area when it has one.
 */
export const nominationName = (
    directory: string | null | undefined,
    editionYear: number | string | null | undefined,
    practiceArea?: string | null
): string =>
    [[directory, editionYear].filter((part) => part != null && part !== '').join(' '), practiceArea]
        .filter(Boolean)
        .join(' · ');
